import React, { useEffect } from 'react'
import { ReactComponent as SuccessIcon } from './Assets/success.svg'
import { observer } from 'mobx-react-lite'
import { Stack, Typography, Box } from '@mui/material'
import { T, useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { runInAction } from 'mobx'
import { storeElement } from 'GlobalStores/Cores/Elements/StoreElement'
import StoreSubScriptions from 'GlobalStores/StoreSubScriptions'

const SkipSuccess = observer(props => {
    const translate = useTranslate()

    useEffect(() => {
        runInAction(() => {
            storeElement.cardTitle.titleStep1 = <T>subscriptions</T>
            storeElement.cardTitle.titleStep2 = <T>skip_next_delivery</T>
            storeElement.cardTitle.titleStep3 = <T>success</T>
            storeElement.settingCard.padding = '50px 40px 20px 40px'
            storeElement.settingCard.titleAlign = 'center'
        })

        return () => {
            runInAction(() => {
                storeElement.cardTitle.titleStep1 = ''
                storeElement.cardTitle.titleStep2 = ''
                storeElement.cardTitle.titleStep3 = ''
                storeElement.settingCard.padding = ''
                storeElement.settingCard.titleAlign = ''
            })
        }
    }, [])

    const date = StoreSubScriptions.GetNextDateDelivery()
    const dateFormat = new Date(date).toLocaleDateString('en-uk', { year: 'numeric', month: 'short', day: 'numeric' })

    return (
        <>
            <Stack justifyContent="center" flexDirection="row">
                <Typography variant="title3">
                    <T>skip_next_delivery</T>
                </Typography>
            </Stack>

            <Stack alignItems={'center'} justifyContent={'center'} textAlign="center" mt="190px">
                <SuccessIcon />

                <Box padding="0px 50px" mt="40px">
                    <Stack mb="15px" gap="10px">
                        <Typography variant="title">
                            <T>success_skip_delivery_title</T>
                        </Typography>

                        <Typography variant="title">
                            <T>success_skip_delivery_title2</T>
                        </Typography>
                    </Stack>

                    <Typography variant="body3" textAlign={'center'} mb="40px" color="#023764" lineHeight="24px">
                        {translate('success_skip_delivery_content').replace('{{date}}', dateFormat)}
                    </Typography>
                </Box>
            </Stack>
        </>
    )
})

export default SkipSuccess
